module.exports = [
  { id: 'facebook', name: 'Facebook' },
  { id: 'twitter', name: 'Twitter' },
  { id: 'google', name: 'Google' },
  { id: 'stumbleupon', name: 'StumbleUpon', hasAccount: true }
]
